import { useURLParamsSetter } from "~/hooks/useURLParamsSetter";

import { useTableSort } from "./useTableSort";

type SortType = "ASC" | "DESC";

interface UseURLTableSortArgs {
  sortField?: string;
  sortType?: string;
  sortableColumns?: string[];
  setParams: ReturnType<typeof useURLParamsSetter>;
}

export const useURLTableSort = ({
  sortField,
  sortType,
  sortableColumns,
  setParams,
}: UseURLTableSortArgs) => {
  const setData = (
    key: string,
    value: string | undefined,
    key2?: string,
    value2?: string | undefined,
  ) => {
    setParams({
      [key]: value,
      ...(key2 ? { [key2]: value2 } : {}),
    });
  };

  return useTableSort({
    sortField,
    sortType,
    sortableColumns,
    setData,
  });
};

export type { SortType };
